var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add',{ref:"add",attrs:{"IsShow":1},on:{"setConfig":_vm.setConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }